import Vue from 'vue'
import store from '../store'
import router from "@/router"

const useIdle = {
    install(vue, options = {}) {
        let timeoutMinutes = options.timeoutMinutes || store.state.lxl.lxl.lxllogin
        let timer
        let lastAction = 0
        const state = Vue.observable({ isIdle: false })
        
        const lastDateAction = localStorage.getItem("lastInteraction")

        if (lastDateAction) {
            const dateFromLastAction = new Date(lastDateAction)
            dateFromLastAction.setMinutes(dateFromLastAction.getMinutes() + timeoutMinutes)

            if (dateFromLastAction < Date.now()) {
                setTimeout(async () => {
                    await revokeToken()
                });
            }
        }

        const resetTimer = () => {
            state.isIdle = false
            clearTimeout(timer)

            if(Date.now() - lastAction > 1000) {
                localStorage.setItem("lastInteraction", new Date().toISOString())
                lastAction = Date.now()
            }

            timer = setTimeout(async () => {
                state.isIdle = true
                await revokeToken()
            }, timeoutMinutes * 60 * 1000)
        }
        
        const revokeToken = async () => {
            await store.dispatch("dc4/revoke")
            router.push("/oryx/login")
        }

        ['mousemove', 'keydown', 'click'].forEach(evt =>
            window.addEventListener(evt, resetTimer) 
        )

         resetTimer()

        Vue.prototype.$idle = {
            state,
            resetTimer
        }
    }
}

export default useIdle